class PressMediaPagination extends HTMLElement {
  constructor() {
    super();
    this.itemsPerPage = parseInt(this.dataset.itemsPerPage);
    this.totalPages = parseInt(this.dataset.totalPages);
    this.sectionId = this.dataset.sectionId;
    this.grid = document.getElementById(`PressMediaGrid-${this.sectionId}`);
    if (!this.grid) return;
    
    this.items = Array.from(this.grid.querySelectorAll('.press-media-grid__item'));
    this.paginationLinks = this.querySelectorAll('a');
    this.prevArrowLi = document.getElementById(`PaginationPrevLi-${this.sectionId}`);
    this.nextArrowLi = document.getElementById(`PaginationNextLi-${this.sectionId}`);
    this.currentPage = 1;

    this.paginationLinks.forEach(link => {
      link.addEventListener('click', this.onClick.bind(this));
    });
  }

  updatePaginationUI(page) {
    this.items.forEach((item, index) => {
      item.style.display = (index >= (page - 1) * this.itemsPerPage && index < page * this.itemsPerPage) ? 'block' : 'none';
    });

    this.querySelectorAll('a[data-type="page"]').forEach(link => {
      if (parseInt(link.dataset.page) === page) {
        link.classList.add('pagination__item--current');
        link.setAttribute('aria-current', 'page');
      } else {
        link.classList.remove('pagination__item--current');
        link.removeAttribute('aria-current');
      }
    });

    if (this.prevArrowLi) {
      this.prevArrowLi.style.display = page > 1 ? 'block' : 'none';
    }
    if (this.nextArrowLi) {
      this.nextArrowLi.style.display = page < this.totalPages ? 'block' : 'none';
    }
  }

  onClick(e) {
    e.preventDefault();
    const type = e.currentTarget.dataset.type;
    
    if (type === 'page') {
      this.currentPage = parseInt(e.currentTarget.dataset.page);
    } else if (type === 'prev' && this.currentPage > 1) {
      this.currentPage--;
    } else if (type === 'next' && this.currentPage < this.totalPages) {
      this.currentPage++;
    }
    
    this.updatePaginationUI(this.currentPage);
    
    const sectionTop = this.grid.closest('.section-press-media').offsetTop;
    window.scrollTo({ top: sectionTop - 40, behavior: 'smooth' });
  }
}

if (!customElements.get('press-media-pagination')) {
  customElements.define('press-media-pagination', PressMediaPagination);
}
